import axios from "axios";
import { ref, computed, watch } from "vue";
import { defineStore } from "pinia";
import { useRouter, useRoute } from "vue-router";
import { useModals } from "@/utils/useModals";
import { useFieldsStore } from "./storeFieldData";
import { useSettingsStore } from "./storeSettings";
import { sendMetrik } from "@/utils/metrika";
import { sendAdriver } from '@/utils/metrika';
import { phoneFormatter } from "@/utils/functions";
import { API_URL } from "@/utils/constans";

export const useRequestsStore = defineStore("request", () => {
	const router = useRouter();
	const route = useRoute();
	const storeField = useFieldsStore();
	const storeSettings = useSettingsStore();
	const { responseOk, closeModal, openModal } = useModals();

	const token = ref(localStorage.getItem("token"));
	const tokenGameFillword = ref(null);
	const tokenGameEmoji = ref(null);
	const setToken = (newToken) => {
		token.value = newToken;
		localStorage.setItem("token", newToken);
	};

	const removeToken = () => {
		token.value = null;
		localStorage.removeItem("token");
	};

	const loaderBtn = ref(false);
	const userData = ref({});
	const userReceiptsData = ref({});
	const userReceiptReults = ref([]);
	const userPrizesData = ref({});
	const listUserPrizes = ref([]);
	const winnersList = ref([]);
	const responseError = ref("");
	const isRegistrationSuccess = ref(false);
	const gameEatPancakesAvailable = ref(false);
	const isAuthenticated = computed(() => !!token.value);
	const isGamingSession = computed(() => userData.value?.games);
	const isEmblemSession = computed(() => userData.value?.emblem);
	const isApprovedChecksCount = computed(() => userData.value?.approved_checks_count >= 1);
	const isMobile = computed(() => storeSettings.widthWindow <= 576);
	const fillWordsPage = computed(() => route.name === "quiz_fill_words");
	const emojisPage = computed(() => route.name === "quiz_emoji");

	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response && error.response.status === 401) {
				removeToken();
				delete axios.defaults.headers.common["Authorization"];
			}
			return Promise.reject(error);
		}
	);

	const setAuthHeader = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const tokenURL = urlParams.get("token");
		if (tokenURL) {
			token.value = tokenURL;
		} else {
			token.value = localStorage.getItem("token");
		}
		if (token.value) {
			axios.defaults.headers.common["Authorization"] = `Bearer ${token.value}`;
		} else {
			delete axios.defaults.headers.common["Authorization"];
		}
	};

	const registration = async () => {
		loaderBtn.value = true;
		const registrationParams = localStorage.getItem("registration_params") || "";

		try {
			const formData = new FormData();

			formData.append("first_name", storeField.fields.firstName.title);
			formData.append("last_name", storeField.fields.lastName.title);
			formData.append("phone_number", storeField.fields.phone.title);
			formData.append("email", storeField.fields.email.title);
			formData.append("password", storeField.fields.passwordRepeat.title);
			formData.append("registration_params", registrationParams);
			formData.append("is_policy", storeField.fields.agreement.title);
			formData.append("is_rules", storeField.fields.rules.title);
			formData.append("agree_to_advertising", storeField.fields.agreeToAdvertising.title);

			const res = await axios.post(`${API_URL}/api/users/registration`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			isRegistrationSuccess.value = true;
			openModal("registrationEnd");
			sendMetrik("reachGoal", "SignUp_SentForm_Success");
			sendAdriver('signup_sentform_success')
			storeField.updateRegestrationBtn();
		} catch (error) {
			console.error("Error sendRegistration", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			console.log("error.response:", error.response);
		} finally {
			loaderBtn.value = false;
		}
	};

	const authorization = async () => {
		loaderBtn.value = true;
		const parameters = {
			email: storeField.fields.email.title,
			password: storeField.fields.password.title,
		};

		try {
			const res = await axios.post(`${API_URL}/api/users/authorization`, parameters);
			setToken(res.data.access);
			setAuthHeader();
			await userInfo();
			closeModal();
			if(emojisPage.value || fillWordsPage.value) {
				router.push({ name: "profile" });
			}
			sendMetrik("reachGoal", "SignIn_SentForm_Success");
			storeField.updateFields("email", "disabledBtn", false);
			storeField.updateFields("password", "disabledBtn", false);
		} catch (error) {
			console.log("error sendAuthorization:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			if(error.response.status === 557) {
				openModal('notVerified')
			}
		} finally {
			loaderBtn.value = false;
		}
	};

	const userInfo = async () => {
		tokenGameFillword.value = localStorage.getItem("tokenGameFillword");
		tokenGameEmoji.value = localStorage.getItem("tokenGameEmoji");
		try {
			setAuthHeader();
			const res = await axios.get(`${API_URL}/api/users/me`);
			userData.value = res.data;
			initWidget();
			if(!!tokenGameFillword.value) {
				await userAddGameFillWords(tokenGameFillword.value);
				localStorage.removeItem("tokenGameFillword");
				tokenGameFillword.value = null;
			}
			if(!!tokenGameEmoji.value) {
				await userAddGameEmoji(tokenGameEmoji.value);
				localStorage.removeItem("tokenGameEmoji");
				tokenGameEmoji.value = null;
			}
		} catch (error) {
			if (error.response && error.response.status === 401) {
				console.warn("Пользователь не авторизован");
				userData.value = null;
			} else {
				console.error("Error getUserInfo", error);
				throw error;
			}
		}
	};

	const verification = async (token, uuid) => {
		try {
			const params = {
				token: token,
				uuid: uuid,
			}
			const res = await axios.patch(`${API_URL}/api/users/registration/accept`, null,  { params });
			setToken(res.data.access);
			router.push({ name: "profile" });
			await userInfo();
			// sendMetrik('reachGoal', 'SignIn_SentForm_Success')
		} catch (error) {
			console.error("Error verification", error);
			// responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			openModal("errorVerified");
		} finally {
		}
	};

	const repeatVerification = async () => {	
		try {	
			const parameters = {
				email: storeField.fields.email.title,
			};		
			const res = await axios.post(`${API_URL}/api/users/resend-verification-email`, parameters);		
			openModal("endRepeatVerified");
		} catch (error) {
			console.error("Error repeatVerification", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			
		}
	};

	const recoveryPassword = async () => {
		loaderBtn.value = true;
		const parameters = {
			email: storeField.fields.email.title,
		};
		try {
			const res = await axios.post(`${API_URL}/api/users/recovery-password`, parameters);
			openModal("sentNewPassword");
		} catch (error) {
			console.log("error sendRecoveryPassword:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			loaderBtn.value = false;
		}
	};

	const changeUserProfile = async () => {
		const parameters = {
			first_name: storeField.fields.firstName.title || userData.value.first_name,
			last_name: storeField.fields.lastName.title || userData.value.last_name,
			phone_number: storeField.fields.phone.title || userData.value.phone_number,
		};
		loaderBtn.value = true;
		try {
			setAuthHeader();
			const res = await axios.put(`${API_URL}/api/users/me`, parameters);
			await userInfo();
			openModal("sentChangeUserProfile");
			setTimeout(() => {
				closeModal("sentChangeUserProfile");
			}, 2000);
		} catch (error) {
			console.log("error changeUserProfile", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			loaderBtn.value = false;
		}
	};

	const changeUserPassword = async () => {
		loaderBtn.value = true;
		const new_password = { new_password: storeField.fields.passwordRepeat.title };
		try {
			setAuthHeader();
			await axios.patch(`${API_URL}/api/users/change-password`, new_password);
			openModal("sentChangeNewPassword");
			setTimeout(() => {
				closeModal("sentChangeNewPassword");
			}, 2000);
		} catch (error) {
			console.error("Error changePassword", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных";
		} finally {
			loaderBtn.value = false;
		}
	};

	const getCollections = async () => {
		try {
			let url = `${API_URL}/api/goods`;
			let allResults = [];

			while (url) {
				const { data } = await axios.get(url);
				allResults = [...allResults, ...data.results];
				url = data.next;
			}

			return allResults;
		} catch (error) {
			console.error("Error getCollections:", error);
		}
	};

	const getPartners = async () => {
		try {
			let url = `${API_URL}/api/partners`;
			let allResults = [];

			while (url) {
				const { data } = await axios.get(url);
				allResults = [...allResults, ...data.results];
				url = data.next;
			}

			return allResults;
		} catch (error) {
			console.error("Error getCollections:", error);
		}
	};

	const getPrizes = async () => {
		try {
			let url = `${API_URL}/api/quiz/prizes`;
			let allResults = [];

			while (url) {
				const { data } = await axios.get(url);
				allResults = [...allResults, ...data.results];
				url = data.next;
			}

			return allResults;
		} catch (error) {
			console.error("Error getCollections:", error);
		}
	};

	const userPrizes = async (offset, limit) => {
		try {
			setAuthHeader();
			const { data } = await axios.get(`${API_URL}/api/quiz/user/prizes?offset=${offset}&limit=${limit}`);
			return data;
		} catch (error) {
			console.error("Error fetching prizes:", error);
		}
	};

	const isChangedPrize = ref(false);
	const setPrize = async (wonId, prizeId) => {
		try {
			setAuthHeader();
			await axios.patch(`${API_URL}/api/quiz/won_prize/${wonId}`, { prize: prizeId});	
			openModal("successSetPrize");	
			isChangedPrize.value = true;	
		} catch (error) {
			console.log(" setPrize:", error);
		}
	}

	const offsetReceipt = ref(0);
	let limitReceipt;
	const loading = ref(false);
	const allLoaded = ref(false);
	const nextList = ref(null);

	if(isMobile.value) {
		limitReceipt = 4;
	} else {
		limitReceipt = 6;
	}

	const mergeReceipts = (current, incoming) => {
		const map = new Map();
		[...incoming, ...current].forEach((r) => {
			map.set(r.id, r);
		});
		// возвращаем массив, отсортированный по дате (новые сверху)
		return Array.from(map.values()).sort((a, b) => new Date(b.upload_date) - new Date(a.upload_date));
	};

	const putRecieptInListReceipts = async () => {
		try {
			const res = await axios.get(`${API_URL}/api/quiz/user/receipts?limit=1000`);
			const results = res.data?.results || [];
			userReceiptsData.value = res.data;
			userReceiptReults.value = mergeReceipts(userReceiptReults.value, results);
		} catch (error) {
			console.log("putRecieptInListReceipts error:", error);
		}
	};	

	const userReceipts = async () => {
		if (loading.value || allLoaded.value) return;
		loading.value = true;
		try {
			setAuthHeader();
			const { data } = await axios.get(`${API_URL}/api/quiz/user/receipts?offset=${offsetReceipt.value}&limit=${limitReceipt}`);
			const results = data?.results || [];
			
			if (results.length < limitReceipt) {
				allLoaded.value = true;
			}
			if(isMobile.value) {
				allLoaded.value = true;
				nextList.value = data.next;
			}

			userReceiptReults.value = mergeReceipts(userReceiptReults.value, results);
			offsetReceipt.value += limitReceipt;

		} catch (error) {
			console.log("userReceipts:", error);
		} finally {
			loading.value = false;
		}
	};

	const showMoreReceipts = async () => {
		offsetReceipt.value += limitReceipt;
		await userReceipts();
	};

	const offsetPrize = ref(0);
	const limitPrize = 20;
	const loadingPrize = ref(false);
	const allLoadedPrize = ref(false);	

	const updateWinnings = () => {
		winnersList.value = [];
		offsetPrize.value = 0;
		allLoadedPrize.value = false;
	};

	const getWinnings = async (type) => {
		
		if (loadingPrize.value || allLoadedPrize.value) return;
		loadingPrize.value = true;

		try {
			const { data } = await axios.get(`${API_URL}/api/quiz/winnings?offset=${offsetPrize.value}&limit=${limitPrize}&prize_type=${type}`);
			const results = data?.results || [];
		
			if (results.length < limitPrize) {
				allLoadedPrize.value = true;
			}

			winnersList.value.push(...results);
			offsetPrize.value += limitPrize;
		} catch (error) {
			console.log("getWinnings error:", error);
		} finally {
			loadingPrize.value = false;
		}
	};

	const getEmailWinnings = async (mail, type) => {
		loadingPrize.value = true;
		winnersList.value = [];
		allLoadedPrize.value = true;
		try {
			let allResults = [];
			const params = {
				user_email: mail
			}
			if(type) params.prize_type = type;
			let url = `${API_URL}/api/quiz/winnings`;
			while(url) {
				const { data } = await axios.get(url, {params});
				url = data.next;
				allResults = [...allResults, ...data.results];
			}

			winnersList.value = allResults;
		} catch (error) {
			console.log("getEmailWinnings error:", error);
		} finally {
			loadingPrize.value = false;
		}
	};

	const offsetPrizeChange = () => {
		offsetPrize.value = 0;
	};

	const feedback = async () => {
		loaderBtn.value = true;

		const parameters = {
			topic: storeField.fields.select.id,
			name: storeField.fields.firstName.title || userData.value.first_name,
			email: storeField.fields.email.title || userData.value.email,
			files: storeField.fields.filesForPost,
			text: storeField.fields.message.title,
			is_policy: storeField.fields.agreement.title,
		};

		const formData = new FormData();

		if (parameters.files && parameters.files.length > 0) {
			for (const file of parameters.files) {
				formData.append("files", file);
			}
		}

		formData.append("topic", parameters.topic);
		formData.append("name", parameters.name);
		formData.append("email", parameters.email);
		formData.append("text", parameters.text);
		formData.append("is_policy", parameters.is_policy);

		try {
			const res = await axios.post(`${API_URL}/api/feedback/send`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});

			openModal("statusOk");
			responseError.value = "";
			storeField.updateFeedbackBtn();
			if (!isAuthenticated.value) {
				userData.value.first_name = "";
				userData.value.email = "";
			}
			sendMetrik("reachGoal", "Feedback_SentForm_Success");
		} catch (error) {
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			console.error("Error sendFeedback", error);
		} finally {
			loaderBtn.value = false;
		}
	};

	const topics = async () => {
		try {
			const res = await axios.get(`${API_URL}/api/feedback/topics?limit=1000`);
			return res.data.results;
		} catch (error) {
			console.error("Error sendFeedback", error);
		}
	};

	const logout = async () => {
		removeToken();
		userData.value = {};
		userReceiptsData.value = {};
		userReceiptReults.value = [];
		listUserPrizes.value = [];
		storeField.updateFiles();
		const widget = document.getElementById("apm-widget");
		if (widget) {
			widget.innerHTML = "";
		}
		router.push({ name: "home" });
		gameEatPancakesAvailable.value = false;
	};

	const startGameFillWords = async (theme) => {
		try {
			setAuthHeader();
			const { data } = await axios.post(`${API_URL}/api/quiz_fillword/start`, theme);
			return data;
		} catch (error) {
			console.log("warn startGameFillWords", error);
		}
	};

	const userAddGameFillWords = async (tokenGame) => {
		try {
			await axios.patch(`${API_URL}/api/quiz_fillword/user?uuid=${tokenGame}`, );			
		} catch (error) {
			console.log("warn userAddGameFillWords", error);
		}
	};

	const userAddGameEmoji = async (tokenGame) => {
		try {
			
			await axios.patch(`${API_URL}/api/quiz_test/user?uuid=${tokenGame}`, );			
		} catch (error) {
			console.log("warn userAddGameEmoji", error);
		}
	};

	const initWidget = () => {
		if (!userData.value || !userData.value.uuid) {
			console.warn("userData.value.uuid is not available");
			return;
		}

		if (!document.getElementById("apm-scan-qr")) {
			qrWidget.init("apm-widget", {
				api: "https://api.apmcheck.ru",
				apiKey: "ea516ecb-d243-4d0a-a5a0-02283190d086",
				userUuid: userData.value.uuid,
				callbacks: {
					onReceiptSentSuccess: () => {
						console.log("true:");
						setTimeout(async () => {
							await userInfo();
							await putRecieptInListReceipts();
						}, 2000);
						sendMetrik("reachGoal", "Check_Download_Success");
						sendAdriver('check_download_success')
					},
					onReceiptSentError: () => {
						console.log("false:");
						// sendMetrik("reachGoal", "reciept_canceled");
					},
				},
				i18n: {
					screens: {
						qrParsed: {
							header: "Чек отправлен",
							subheader: "Ваш чек принят в обработку",
						},
						scanQr: {
							header: "Загрузка чека",
							subheader: "Наведите камеру на QR-код",
						},
						cameraNotAvailable: {
							subheader: 'Мы не можем получить доступ к камере устройства.<br>Разреши браузеру обращаться к камере или введи данные с чека вручную'
						},
					},
				},
			});
		}
	};

	return {
		setAuthHeader,
		registration,
		authorization,
		recoveryPassword,
		logout,
		userInfo,
		verification,
		repeatVerification,
		userReceipts,
		showMoreReceipts,
		userPrizes,
		setPrize,
		changeUserProfile,
		changeUserPassword,
		topics,
		feedback,
		updateWinnings,
		getWinnings,
		getEmailWinnings,
		offsetPrizeChange,
		getCollections,
		getPartners,
		getPrizes,
		startGameFillWords,

		isAuthenticated,
		loaderBtn,
		userData,
		userReceiptReults,
		userReceiptsData,
		userPrizesData,
		listUserPrizes,
		responseError,
		isGamingSession,
		isEmblemSession,
		allLoaded,
		loading,
		nextList,
		allLoadedPrize,
		loadingPrize,
		winnersList,
		isApprovedChecksCount,
		isChangedPrize,
		isRegistrationSuccess,
	};
});
